<template>
  <div>
    <h3>Placeholder for Substitute Products - 404 pages</h3>
    <div class="xsell_grid">
        <div>Product</div>
        <div>Product</div>
        <div>Product</div>
    </div>
  </div>
</template>

<script>

// let site = require(process.env.VUE_APP_SITE_JS)

export default {
   data: () => ({
  }),
  methods : {
  },
  created () {
    this.$emit('displayReady',true)
  },

};
</script>
<style scoped>
.xsell_grid {
    display: grid;
    grid-template-columns: repeat(3,200px);
    grid-template-rows: 200px;
    align-items: center
}
</style>